import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import api from "../services/api";
import "./AddPurchase.css";
import { useNavigate } from "react-router-dom";

const AddSupplier = () => {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    state: "",
    city: "",
    pin_code: "",
    phoneNo: "",
    gstNo: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    // if (!formData.address.trim()) newErrors.address = "Address is required";
    // if (!formData.state.trim()) newErrors.state = "State is required";
    // if (!formData.city.trim()) newErrors.city = "City is required";
    // if (!formData.pin_code || !/^\d{6}$/.test(formData.pin_code)) 
    //   newErrors.pin_code = "Valid 6-digit pin code is required";
    if (!formData.phoneNo || !/^\d{10}$/.test(formData.phoneNo)) 
      newErrors.phoneNo = "Valid 10-digit phone number is required";
    // if (formData.gstNo && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formData.gstNo)) 
    //   newErrors.gstNo = "Valid GST number is required";
    // if (!formData.gstNo.trim()) newErrors.gstNo = "GST Number is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setErrors({});
    setSubmitError(null);
    setLoading(true);

    const payload = {
      name: formData.name,
      mobile: formData.phoneNo,
      gst_no: formData.gstNo || "",
      city: formData.city,
      state: formData.state,
      address: formData.address,
      pin_code: formData.pin_code
    };

    try {
      const response = await api.post("/supplier_add.php", payload);
      
      if (response.data.head.code === 200) {
        const supplierId = response.data.body.supplier_id;
        alert(`Supplier added successfully! Supplier ID: ${supplierId}`);
        
        setFormData({
          name: "",
          address: "",
          state: "",
          city: "",
          pin_code: "",
          phoneNo: "",
          gstNo: "",
        });
         navigate("/supplierlist");
      } else {
        setSubmitError(response.data.head.msg || "Failed to add supplier");
        alert(`Error: ${response.data.head.msg}`);
      }
    } catch (err) {
      console.error("Error adding supplier:", err);
      setSubmitError("Failed to add supplier. Please try again.");
      alert("Failed to add supplier. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Supplier</h4>
        <Button className="btn-top" onClick={() => window.history.back()}>Back</Button>
      </div>

      {submitError && (
        <div className="alert alert-danger" role="alert">
          {submitError}
        </div>
      )}

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Supplier Name</Form.Label>
              <Form.Control
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter supplier name"
                isInvalid={!!errors.name}
                disabled={loading}
              />
              {renderError("name")}
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                name="phoneNo"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={10}
                value={formData.phoneNo}
                onChange={handleChange}
                placeholder="10-digit phone number"
                isInvalid={!!errors.phoneNo}
                disabled={loading}
              />
              {renderError("phoneNo")}
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="address"
                as="textarea"
                rows={2}
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter street address"
                isInvalid={!!errors.address}
                disabled={loading}
              />
              {renderError("address")}
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>City</Form.Label>
              <Form.Control
                name="city"
                type="text"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                isInvalid={!!errors.city}
                disabled={loading}
              />
              {renderError("city")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>State</Form.Label>
              <Form.Control
                name="state"
                type="text"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                isInvalid={!!errors.state}
                disabled={loading}
              />
              {renderError("state")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Pin Code</Form.Label>
              <Form.Control
                name="pin_code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={formData.pin_code}
                onChange={handleChange}
                placeholder="6-digit pin code"
                isInvalid={!!errors.pin_code}
                disabled={loading}
              />
              {renderError("pin_code")}
            </Form.Group>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>GST Number (Optional)</Form.Label>
              <Form.Control
                name="gstNo"
                type="text"
                value={formData.gstNo}
                onChange={(e) => setFormData({ ...formData, gstNo: e.target.value.toUpperCase() })}
                placeholder="e.g., 22ABCDE1234F1Z5"
                isInvalid={!!errors.gstNo}
                disabled={loading}
              />
              {renderError("gstNo")}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button 
            type="submit" 
            className="btn-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Adding...
              </>
            ) : (
              "Submit"
            )}
          </Button>
          <Button 
            type="button" 
            className="btn-top" 
            onClick={() => window.history.back()}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AddSupplier;